import {
  ComponentRef,
  Injectable,
  ViewContainerRef
} from '@angular/core';

import { Subscription, take } from 'rxjs';
import { PiModalMensajeGenericoPasosComponent } from '../components/pi-modal-mensaje-generico/pi-modal-mensaje-generico.component';



export interface PiModalMensajeGenericoConfig {
  title?: string;
  subtitle?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  urlDestino?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PiModalMensajeGenericoService {

  private outlet: ViewContainerRef | null = null;

  private modalRef:
    ComponentRef<PiModalMensajeGenericoPasosComponent> | null = null;

  private closedSubscription: Subscription | null = null;

  /**
   * Registra el contenedor global donde se creará el modal.
   */
  registerOutlet(outlet: ViewContainerRef): void {
    this.outlet = outlet;
  }

  /**
   * Deja de utilizar el contenedor cuando se destruye el host.
   */
  unregisterOutlet(outlet: ViewContainerRef): void {
    if (this.outlet !== outlet) {
      return;
    }

    this.close();
    this.outlet = null;
  }

  /**
   * Crea el modal y asigna sus inputs.
   */
  open(config: PiModalMensajeGenericoConfig): void {
    if (!this.outlet) {
      throw new Error(
        'ModalHostComponent no ha registrado el contenedor del modal.'
      );
    }

    // Garantiza que solo exista un modal abierto a la vez.
    this.close();

    const ref = this.outlet.createComponent(
      PiModalMensajeGenericoPasosComponent
    );

    this.modalRef = ref;

    ref.setInput('title', config.title ?? '');
    ref.setInput('subtitle', config.subtitle ?? '');
    ref.setInput(
      'primaryButtonText',
      config.primaryButtonText ?? ''
    );
    ref.setInput(
      'secondaryButtonText',
      config.secondaryButtonText ?? ''
    );
    ref.setInput(
      'urlDestino',
      config.urlDestino ?? '/'
    );

    // Cerrar el modal cuando el componente emite el evento.
    this.closedSubscription = ref.instance.closed
      .pipe(take(1))
      .subscribe(() => this.close());

    // Fuerza la primera detección de cambios.
    ref.changeDetectorRef.detectChanges();
  }

  /**
   * Destruye el modal actual, si existe.
   */
  close(): void {
    this.closedSubscription?.unsubscribe();
    this.closedSubscription = null;

    const ref = this.modalRef;
    this.modalRef = null;

    if (!ref) {
      return;
    }

    const index = this.outlet?.indexOf(ref.hostView) ?? -1;

    if (this.outlet && index >= 0) {
      this.outlet.remove(index);
    } else {
      ref.destroy();
    }
  }
}